export default __webpack_public_path__ + "static/media/ESSC16LSAP02_1920x1080.415c6931.jpg";